export default {"src":"/_next/static/media/arrow-right.17e1b298.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};